import React, { useState } from "react";

/**
 * Section repliable pour les éditeurs de cellule.
 *
 * Regroupe des champs sous un titre cliquable afin de réduire la charge
 * visuelle des éditeurs longs (cf. PhotoboothGifCell2Editor). Purement
 * présentationnel : aucune donnée n'est touchée, on n'enveloppe que du markup.
 *
 * Usage :
 *   <EditorSection title="Couleurs">
 *     <div className="tsk-input-line">…</div>
 *   </EditorSection>
 *
 * Props :
 *   - title       : libellé de l'en-tête (string ou node, ex. <FormattedMessage/>)
 *   - children    : contenu de la section
 *   - defaultOpen : ouvert au montage (défaut true)
 *   - nested      : sous-section (style allégé) à l'intérieur d'une EditorSection
 */
function EditorSection({ title, children, defaultOpen = true, nested = false, help }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section
      className={
        `tsk-editor-section${open ? " tsk-editor-section--open" : ""}` +
        (nested ? " tsk-editor-section--nested" : "")
      }
    >
      <div className="tsk-editor-section__headwrap">
        <button
          type="button"
          className="tsk-editor-section__header"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="tsk-editor-section__chevron" aria-hidden="true">▸</span>
          <span className="tsk-editor-section__title">{title}</span>
        </button>
        {help}
      </div>
      {open && <div className="tsk-editor-section__body">{children}</div>}
    </section>
  );
}

export default EditorSection;
